import { CandidateService } from 'src/app/_services/candidate.service';
import { TalentpoolService } from '../../_services/talentpool.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, AbstractControl } from '@angular/forms';
import { Component, OnInit, TemplateRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
declare const clevertap;

@Component({
    selector: 'app-create-talentpool',
    templateUrl: './create-talentpool.component.html',
    styleUrls: ['./create-talentpool.component.scss'],
    standalone: false
})
export class CreateTalentpoolComponent implements OnInit {

  talentpool_form: UntypedFormGroup;
  success_message: string;
  talentpooldetails: any;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Input() TalentpoolIDtoEdit: any;

  @ViewChild('successModal') successModal: TemplateRef<any>;
  @ViewChild('errorModal') errorModal: TemplateRef<any>;

  constructor(private fb: UntypedFormBuilder, private talentpoolservice: TalentpoolService, public modalService: NgbModal, private candidateservice: CandidateService,
    private _localstorageservice: LocalStorageService) { }

  async ngOnInit() {
    this.talentpool_form = this.fb.group({
      talentpoolname: ['', [Validators.required ,noWhitespaceValidator, ValidateHTMLTAGS]],
      talentpooldescription: ['', [ValidateHTMLTAGS]]
    })

    function noWhitespaceValidator(control: AbstractControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'required': true };
    }

    function ValidateHTMLTAGS(control: AbstractControl){
      if(control.value){
        const res = control.value.replace(/ /g, '')
        let scriptRegex = /^[a-zA-Z0-9\-'\.,@&\/\+\:\#_\(\)\"\'\* ]*$/;
        if(res && (!scriptRegex.test(res.trim()) == true)){
          return { 'pattern': true }
        }else{
          return null
        }
      }
    }

    if (this.TalentpoolIDtoEdit) {
      try {
        // made async-await instead of listing to subscription so that the form is filled with the data before the form is rendered
        const response = await this.talentpoolservice.getTalentpoolList(this._localstorageservice.getItem('usernumber')).toPromise();
        if(response.status === 'success') {
          this.talentpooldetails = response.data.talentpools.filter((x: any) => { return x.talentpoolnumber == this.TalentpoolIDtoEdit })[0];
          this.talentpool_form.patchValue({
            talentpoolname: this.talentpooldetails.name,
            talentpooldescription: this.talentpooldetails.description
          })
        }
      } catch (error) {
        console.error(error);
      }
    }

  }

  createTalentpool() {
    if (this.talentpool_form.valid) {
      let data = {
        talentpoolnumber: this.talentpooldetails ? this.talentpooldetails.talentpoolnumber : null,
        name: this.talentpool_form.value.talentpoolname,
        description: this.talentpool_form.value.talentpooldescription,
        usernumber: this._localstorageservice.getItem('usernumber')
      }

      if (this.TalentpoolIDtoEdit) {
        this.talentpoolservice.updateTalentpoolDetails(data).subscribe((res: any) => {
          if (res.status == 'success') {
            // this.success_message = "Talentpool Updated Successfully";
            // const modalRef = this.modalService.open(this.successModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
            this.modalService.dismissAll();
            this.talentpoolservice.createTalentpoolData();
            this.passEntry.emit('talentpool-edited');
          }
        })
      }
      else {
        this.talentpoolservice.createTalentpool(data).subscribe((res: any) => {
          if (res.status == 'success') {
            // this.success_message = "Talentpool Created Successfully";
            // const modalRef = this.modalService.open(this.successModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
            this.modalService.dismissAll();
            this.passEntry.emit('talentpool-added');
            this.candidateservice.createCandidateData();
            // this.talentpoolservice.createTalentpoolData();
            //- Clevertap Create Talentpool event
            const talentpoolObj = {
              "User ID": this._localstorageservice.getItem('userdata').userid,
              "Talentpool Name": data.name,
              "Number of Candidates": 0,
              "Source": "My Talentpool"
            }
            clevertap.event.push('Create Talentpool', talentpoolObj)
          } else if (res.status == 'failure' && res.message == 'insufficient credits') {
            this.passEntry.emit('notpcredits');
          }
        })
      }
    }
    else {
      this.validateAllFormFields(this.talentpool_form)
    }

  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  dismiss() {
    this.modalService.dismissAll();
  }

  cleverTapEvent(eventName, data) {
   // clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }
}
